export default __webpack_public_path__ + "static/media/ConveyorLiftMK3.256.fa6a4051.png";